import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// import { getUrlVariable } from "./utils/extractUrl"
// import VConsole from 'vconsole'
// let k = getUrlVariable('from_user_id')
// if (k == '123657') {
//     const vConsole = new VConsole()
//     Vue.use(vConsole)
// }
Vue.config.productionTip = false
Vue.config.ignoredElements = ['wx-open-launch-app'];
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')